/* Skapad av Claude Code — bildkort och stjärnfördelning för svd-lp-smile-recensioner.

   Båda byggs ur den HTML Judge.me redan har lagt i produktens metafält:
     · bildkorten ur .jdgm-gallery-data[data-json]
     · fördelningen ur .jdgm-histogram__row[data-rating]
   Inga API-anrop, och inget går sönder om appen avinstalleras — då finns datan
   inte och behållarna förblir dolda.

   Judge.mes egen JS bygger om delar av widgeten efter att sidan laddats, så vi
   försöker några gånger innan vi ger upp. */

(function () {
  'use strict';

  var ATTEMPTS = [0, 400, 1200, 3000, 6000];

  function starStrip(rating, px) {
    var wrap = document.createElement('span');
    wrap.className = 'svd-smrec__stars';
    wrap.setAttribute('role', 'img');
    wrap.setAttribute(
      'aria-label',
      'Betyg ' + String(rating).replace('.', ',') + ' av 5'
    );
    if (px) {
      wrap.style.width = px * 5 + 'px';
      wrap.style.height = px + 'px';
      wrap.style.webkitMaskSize = px + 'px ' + px + 'px';
      wrap.style.maskSize = px + 'px ' + px + 'px';
    }
    var fill = document.createElement('span');
    fill.className = 'svd-smrec__stars-fill';
    fill.style.width = Math.max(0, Math.min(100, rating * 20)) + '%';
    wrap.appendChild(fill);
    return wrap;
  }

  function safeImage(url) {
    return typeof url === 'string' && url.indexOf('https://') === 0 ? url : '';
  }

  function buildPhotos(root) {
    var box = root.querySelector('[data-svd-smrec-photos]');
    if (!box) return true;                      /* avstängt i customizern */
    if (box.childElementCount) return true;     /* redan byggt */

    /* ögonblicksbilden som sektionen tog medan sidan parsades ligger först —
       Judge.mes egen JS hinner annars plocka bort .jdgm-gallery-data */
    var raw = root.getAttribute('data-gallery-json');
    if (!raw) {
      var data = root.querySelector('.jdgm-gallery-data');
      raw = data ? data.getAttribute('data-json') : '';
    }
    if (!raw) return false;

    var items;
    try {
      items = JSON.parse(raw);
    } catch (e) {
      return false;
    }
    if (!Array.isArray(items) || !items.length) return false;

    var max = parseInt(root.getAttribute('data-photo-max'), 10) || 5;
    var list = root.querySelector('.svd-smrec__list');
    var made = 0;

    items.forEach(function (rev) {
      if (made >= max || !rev || !Array.isArray(rev.pictures_urls)) return;
      var pic = rev.pictures_urls[0] || {};
      var src = safeImage(pic.compact || pic.original);
      if (!src) return;

      var name = rev.reviewer_name || 'Kund';
      var card = document.createElement('button');
      card.type = 'button';
      card.className = 'svd-smrec__photo';

      var img = document.createElement('img');
      img.src = src;
      img.loading = 'lazy';
      img.alt = 'Kundbild från ' + name + 's omdöme';
      card.appendChild(img);

      var body = document.createElement('div');
      body.className = 'svd-smrec__photo-body';
      body.appendChild(starStrip(parseFloat(rev.rating) || 5, 12));

      var who = document.createElement('p');
      who.className = 'svd-smrec__photo-name';
      who.textContent = name;
      body.appendChild(who);

      if (rev.title) {
        var title = document.createElement('p');
        title.className = 'svd-smrec__photo-title';
        title.textContent = rev.title;
        body.appendChild(title);
      }

      card.appendChild(body);

      card.addEventListener('click', function () {
        if (list) list.scrollIntoView({ behavior: 'smooth', block: 'start' });
      });

      box.appendChild(card);
      made += 1;
    });

    if (!made) return false;
    box.hidden = false;
    return true;
  }

  function buildHistogram(root) {
    var box = root.querySelector('[data-svd-smrec-hist]');
    if (!box) return true;                      /* avstängt i customizern */
    if (box.childElementCount) return true;     /* redan byggt */

    var rows = root.querySelectorAll('.jdgm-histogram__row[data-rating]');
    if (!rows.length) return false;

    var made = 0;

    Array.prototype.forEach.call(rows, function (row) {
      var stars = row.getAttribute('data-rating');
      var freq = row.getAttribute('data-frequency');
      var pct = row.getAttribute('data-percentage');
      if (!stars || freq === null || pct === null) return;

      var line = document.createElement('button');
      line.type = 'button';
      line.className = 'svd-smrec__hist-row';
      line.setAttribute('data-rating', stars);
      line.setAttribute('aria-pressed', 'false');
      line.setAttribute(
        'aria-label',
        'Visa de ' + freq + ' omdömen med ' + stars + ' stjärnor'
      );
      line.addEventListener('click', function () {
        toggleFilter(root, stars);
      });

      var label = document.createElement('span');
      label.className = 'svd-smrec__hist-label';
      label.textContent = stars + ' ★';
      line.appendChild(label);

      var bar = document.createElement('span');
      bar.className = 'svd-smrec__hist-bar';
      var inner = document.createElement('i');
      inner.style.width = Math.max(0, Math.min(100, parseFloat(pct) || 0)) + '%';
      bar.appendChild(inner);
      line.appendChild(bar);

      var num = document.createElement('span');
      num.className = 'svd-smrec__hist-num';
      num.textContent = freq + ' (' + pct + ' %)';
      line.appendChild(num);

      box.appendChild(line);
      made += 1;
    });

    if (!made) return false;

    var reset = document.createElement('button');
    reset.type = 'button';
    reset.className = 'svd-smrec__hist-reset';
    reset.textContent = root.getAttribute('data-reset-label') || 'Visa alla omdömen';
    reset.hidden = true;
    reset.addEventListener('click', function () {
      toggleFilter(root, null);
    });
    box.appendChild(reset);

    box.hidden = false;
    return true;
  }

  /* Judge.mes egna histogramrader sköter filtreringen — vi vidarebefordrar
     klicket dit i stället för att bygga en egen filtermotor. Raderna ligger
     kvar i DOM:en, bara dolda med CSS, så click() når lyssnaren. */
  function toggleFilter(root, stars) {
    var active = root.getAttribute('data-active-rating');
    var next = stars && active !== stars ? stars : null;

    var target = next
      ? root.querySelector('.jdgm-histogram__row[data-rating="' + next + '"] .jdgm-histogram__star')
      : root.querySelector('.jdgm-histogram__clear-filter');

    if (!target) return;
    target.click();

    if (next) {
      root.setAttribute('data-active-rating', next);
    } else {
      root.removeAttribute('data-active-rating');
    }

    Array.prototype.forEach.call(
      root.querySelectorAll('.svd-smrec__hist-row'),
      function (row) {
        var on = row.getAttribute('data-rating') === next;
        row.classList.toggle('is-active', on);
        row.setAttribute('aria-pressed', on ? 'true' : 'false');
      }
    );

    var reset = root.querySelector('.svd-smrec__hist-reset');
    if (reset) reset.hidden = !next;

    var list = root.querySelector('.svd-smrec__list');
    if (list) list.scrollIntoView({ behavior: 'smooth', block: 'start' });
  }

  /* Judge.me lämnar avatarcirkeln tom. Vi sätter en liten streckikon i den —
     körs om vid sidbyte i listan, eftersom korten då byts ut. */
  var ICON =
    '<svg class="svd-smrec__avatar-icon" width="18" height="18" viewBox="0 0 24 24"' +
    ' fill="none" stroke="currentColor" stroke-width="1.7" stroke-linecap="round"' +
    ' stroke-linejoin="round" aria-hidden="true">' +
    '<circle cx="12" cy="8.5" r="3.5"/>' +
    '<path d="M4.5 20c0-3.6 3.4-5.5 7.5-5.5s7.5 1.9 7.5 5.5"/></svg>';

  function fillIcons(root) {
    Array.prototype.forEach.call(
      root.querySelectorAll('.jdgm-rev__icon'),
      function (icon) {
        if (icon.querySelector('svg')) return;
        icon.textContent = '';
        icon.insertAdjacentHTML('afterbegin', ICON);
      }
    );
  }

  function watchReviews(root) {
    if (root.hasAttribute('data-svd-smrec-watched')) return;
    var list = root.querySelector('.jdgm-rev-widg__reviews');
    if (!list || !('MutationObserver' in window)) return;
    root.setAttribute('data-svd-smrec-watched', '');
    new MutationObserver(function () {
      fillIcons(root);
    }).observe(list, { childList: true, subtree: true });
  }

  function fill(root) {
    var done = true;
    try {
      if (!buildPhotos(root)) done = false;
      if (!buildHistogram(root)) done = false;
      fillIcons(root);
    } catch (e) {
      done = false;
    }
    return done;
  }

  function start(root) {
    if (root.hasAttribute('data-svd-smrec-ready')) return;
    root.setAttribute('data-svd-smrec-ready', '');

    ATTEMPTS.forEach(function (delay) {
      window.setTimeout(function () {
        if (!root.hasAttribute('data-svd-smrec-done') && fill(root)) {
          root.setAttribute('data-svd-smrec-done', '');
        }
        watchReviews(root);
      }, delay);
    });
  }

  function init() {
    Array.prototype.forEach.call(
      document.querySelectorAll('[data-svd-smrec]'),
      start
    );
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }

  /* sektionen kan läggas in eller flyttas i customizern utan omladdning */
  document.addEventListener('shopify:section:load', function (event) {
    var root = event.target.querySelector
      ? event.target.querySelector('[data-svd-smrec]')
      : null;
    if (root) start(root);
  });
})();
